import React from "react";
import { Link } from "react-router-dom";
import "./footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-menu">
        <Link to="/">Home</Link>
        <Link to="/latest-jobs">Latest Jobs</Link>
        <Link to="/admit-card">Admit Card</Link>
        <Link to="/results">Results</Link>
        <Link to="/admission">Admission</Link>
        <Link to="/answer-key">Answer key</Link>
        <Link to="/syllabus">Syllabus</Link>
        <Link to="/about-us">About-us</Link>
        <Link to="/contact-us">Contact-us</Link>
        <Link to="/privacy-policy">Privacy-policy</Link>
        <Link to="/disclaimer">Disclaimer</Link>
        <Link to="/terms">Terms</Link>
      </div>
      <div className="footer-copy">
        © {new Date().getFullYear()} AAMSCHOOL. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
